import React, { useEffect, useState } from "react";
import {
  Anchor,
  Waves,
  Zap,
  Users,
  Save
} from "lucide-react";

const iconMap = {
  Anchor,
  Waves,
  Zap,
  Users
};

const SignatureExperience = () => {

  const [section, setSection] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetch("/api/signature-experience")
      .then((res) => {
        if (!res.ok) {
          throw new Error("Failed to fetch section");
        }

        return res.json();
      })
      .then((data) => {
        setSection(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  }, []);


  const handleSectionTitleChange = (e) => {
    setSection({
      ...section,
      sectionTitle: e.target.value
    });
  };


  const handlePillarChange = (index, field, value) => {

    const updatedPillars = [...section.pillars];

    updatedPillars[index] = {
      ...updatedPillars[index],
      [field]: value
    };

    setSection({
      ...section,
      pillars: updatedPillars
    });
  };


  const handleSave = async () => {

    try {

      setSaving(true);

      const response = await fetch(
        "/api/signature-experience",
        {
          method: "PUT",

          headers: {
            "Content-Type": "application/json",
            Authorization:
              `Bearer ${localStorage.getItem(
                "indiaboatsAdminToken"
              )}`
          },

          body: JSON.stringify(section)
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.message || "Failed to save section"
        );
      }

      setSection(data.data);

      alert("Changes saved successfully");

    } catch (error) {

      console.error(error);

      alert(
        error.message || "Failed to save changes"
      );

    } finally {

      setSaving(false);

    }
  };


  if (loading) {
    return (
      <div className="cms-loading">
        Loading Signature Sea Experience...
      </div>
    );
  }


  if (!section) {
    return (
      <div className="cms-error">
        Unable to load Signature Sea Experience.
      </div>
    );
  }


  return (

    <div className="cms-page">

      {/* PAGE HEADER */}

      <div className="cms-page-heading">

        <div>

          <h2>
            Sea Experiences
          </h2>

          <p>
            Manage the Signature Sea Experience
            section of the IndiaBoats website.
          </p>

        </div>

        <button
          type="button"
          className="cms-save-btn"
          onClick={handleSave}
          disabled={saving}
        >

          <Save size={17} />

          {saving
            ? "Saving..."
            : "Save Changes"
          }

        </button>

      </div>


      {/* SECTION SETTINGS */}

      <div className="cms-editor-card">

        <div className="cms-editor-card-header">

          <div>

            <h3>
              Section Settings
            </h3>

            <p>
              Basic content displayed above
              the experience cards.
            </p>

          </div>

        </div>


        <div className="cms-form-grid">
        <div className="cms-form-group">

          <label>
            Section Title
          </label>

          <input
            type="text"
            value={section.sectionTitle || ""}
            onChange={handleSectionTitleChange}
          />

        </div>


        <div className="cms-form-group">

  <label>
    Background Video
  </label>

  <div className="cms-video-upload-box">

    {section.video ? (
      <video
        className="cms-video-preview"
        src={
          section.video.startsWith("http")
            ? section.video
            : section.video.startsWith("/uploads/")
              ? `${section.video}`
              : section.video
        }
        controls
        muted
      />
    ) : (
      <div className="cms-video-empty">
        No video selected
      </div>
    )}

    <div className="cms-video-upload-actions">

      <input
        type="file"
        id="signature-background-video"
        accept="video/mp4,video/webm,video/quicktime"
        className="cms-file-input"
        onChange={async (e) => {

          const file = e.target.files[0];

          if (!file) {
            return;
          }

          try {

            const formData = new FormData();

            formData.append(
              "image",
              file
            );

            const response = await fetch(
              "/api/upload",
              {
                method: "POST",

                headers: {
                  Authorization:
                    `Bearer ${localStorage.getItem(
                      "indiaboatsAdminToken"
                    )}`
                },

                body: formData
              }
            );

            const data =
              await response.json();

            if (!response.ok) {
              throw new Error(
                data.message ||
                "Video upload failed"
              );
            }

            setSection({
              ...section,
              video: data.fileUrl
            });

          } catch (error) {

            console.error(
              "Video upload error:",
              error
            );

            alert(
              error.message ||
              "Failed to upload video"
            );

          }

        }}
      />

      <label
        htmlFor="signature-background-video"
        className="cms-upload-btn"
      >
        Choose Video
      </label>

    </div>

  </div>

  <small>
    MP4, WEBM or MOV. Maximum 100MB.
  </small>

</div>
</div>

      </div>


      {/* EXPERIENCE CARDS */}

      <div className="cms-section-title">

        <div>

          <h3>
            Experience Cards
          </h3>

          <p>
            Manage the four experience cards
            displayed on the website.
          </p>

        </div>

      </div>


      <div className="cms-experience-grid">

        {section.pillars.map((pillar, index) => {

          const IconComponent =
            iconMap[pillar.icon];

          return (

            <div
              className="cms-experience-card"
              key={pillar.id || index}
            >

              {/* CARD HEADER */}

              <div className="cms-card-header">

                <div className="cms-card-number">
                  {pillar.id}
                </div>

                <div className="cms-card-icon">

                  {IconComponent && (
                    <IconComponent size={25} />
                  )}

                </div>

              </div>


              {/* IMAGE */}

              <div className="cms-image-preview">

  {pillar.image ? (
    <img
      src={
        pillar.image.startsWith("http")
          ? pillar.image
          : pillar.image.startsWith("/uploads/")
            ? `${pillar.image}`
            : pillar.image
      }
      alt={pillar.title}
    />
  ) : (
    <span>No image available</span>
  )}

</div>


              {/* FORM */}

              <div className="cms-form-group">

                <label>
                  Title
                </label>

                <input
                  type="text"
                  value={pillar.title || ""}
                  onChange={(e) =>
                    handlePillarChange(
                      index,
                      "title",
                      e.target.value
                    )
                  }
                />

              </div>


              <div className="cms-form-group">

                <label>
                  Description
                </label>

                <textarea
                  rows="3"
                  value={pillar.desc || ""}
                  onChange={(e) =>
                    handlePillarChange(
                      index,
                      "desc",
                      e.target.value
                    )
                  }
                />

              </div>


              <div className="cms-form-group">

                <label>
                  Capacity
                </label>

                <input
                  type="text"
                  value={pillar.capacity || ""}
                  onChange={(e) =>
                    handlePillarChange(
                      index,
                      "capacity",
                      e.target.value
                    )
                  }
                />

              </div>


              <div className="cms-form-row">

                <div className="cms-form-group">

                  <label>
                    Icon
                  </label>

                  <select
                    value={pillar.icon || ""}
                    onChange={(e) =>
                      handlePillarChange(
                        index,
                        "icon",
                        e.target.value
                      )
                    }
                  >

                    <option value="Anchor">
                      Anchor
                    </option>

                    <option value="Waves">
                      Waves
                    </option>

                    <option value="Zap">
                      Zap
                    </option>

                    <option value="Users">
                      Users
                    </option>

                  </select>

                </div>


                <div className="cms-form-group">

                  <label>
                    Card ID
                  </label>

                  <input
                    type="text"
                    value={pillar.id || ""}
                    onChange={(e) =>
                      handlePillarChange(
                        index,
                        "id",
                        e.target.value
                      )
                    }
                  />

                </div>

              </div>


              <div className="cms-form-group">

                <label>
                  Page Name / URL
                </label>

                <input
                  type="text"
                  value={pillar.pagename || ""}
                  onChange={(e) =>
                    handlePillarChange(
                      index,
                      "pagename",
                      e.target.value
                    )
                  }
                />

              </div>


             <div className="cms-form-group">

  <label>
    Card Image
  </label>

  <div className="cms-upload-box">

    <div className="cms-upload-preview">

      {pillar.image ? (
        <img
          src={
            pillar.image.startsWith("http")
              ? pillar.image
              : `${pillar.image}`
          }
          alt={pillar.title}
        />
      ) : (
        <span>
          No image selected
        </span>
      )}

    </div>

    <div className="cms-upload-actions">

      <input
        type="file"
        id={`pillar-image-${index}`}
        accept="image/jpeg,image/jpg,image/png,image/webp"
        className="cms-file-input"
        onChange={async (e) => {

          const file = e.target.files[0];

          if (!file) {
            return;
          }

          try {

            const formData = new FormData();

            formData.append("image", file);

            const response = await fetch(
              "/api/upload",
              {
                method: "POST",
                headers: {
                  Authorization:
                    `Bearer ${localStorage.getItem(
                      "indiaboatsAdminToken"
                    )}`
                },
                body: formData
              }
            );

            const data =
              await response.json();

            if (!response.ok) {
              throw new Error(
                data.message || "Image upload failed"
              );
            }

            handlePillarChange(
              index,
              "image",
              data.fileUrl
            );

          } catch (error) {

            console.error(
              "Image upload error:",
              error
            );

            alert(
              "Failed to upload image"
            );

          }

        }}
      />

      <label
        htmlFor={`pillar-image-${index}`}
        className="cms-upload-btn"
      >
        Choose Image
      </label>

    </div>

  </div>

  <small>
    JPG, JPEG, PNG or WEBP. Maximum 10MB.
  </small>

</div>

            </div>

          );

        })}

      </div>


      {/* BOTTOM SAVE */}

      <div className="cms-bottom-actions">

        <button
          type="button"
          className="cms-save-btn"
          onClick={handleSave}
          disabled={saving}
        >

          <Save size={17} />

          {saving
            ? "Saving..."
            : "Save Changes"
          }

        </button>

      </div>

    </div>

  );
};

export default SignatureExperience;